<template>
    <div>
        <h1 class="title is-3">Auditorías</h1>
        <!-- Tabla buefy de auditorías -->
        <section>
            <b-table
            :data="auditorias" hoverable>
                <template v-for="column in columns">
                    <b-table-column :key="column.id" v-bind="column">
                        <template
                            v-if="column.searchable && !column.numeric"
                            #searchable="props">
                            <b-input
                                v-model="props.filters[props.column.field]"
                                placeholder="Buscar..."
                                icon="magnify"
                                size="is-small" />
                        </template>
                        <template v-slot="props">
                            {{ props.row[column.field] }}
                        </template>
                    </b-table-column>
                </template>
                <b-table-column label="Estado" centered field='nota' v-slot="props">
                    <b-message v-if="props.row.nota" type="is-warning" has-icon size="is-medium">Con notas</b-message>
                    <b-message v-if="!props.row.nota" type="is-success" has-icon size="is-medium">Sin notas</b-message>
                    <!--<b-tag v-if="props.row.nota" size="is-large" type="is-danger is-rounded">Con notas</b-tag>
                    <b-tag v-if="!props.row.nota" size="is-large" type="is-success is-rounded">Sin notas</b-tag>-->
                </b-table-column>
                <b-table-column label="Acciones" centered field='id' v-slot="props">
                    <router-link :to="{name: 'Editar', params: {id: props.row.id}}">
                        <button class="button is-success is-rounded">
                            <span class="icon">
                            <i class="fas fa-edit"></i>
                            </span>
                            <span>Editar</span>
                        </button>
                    </router-link>
                    <button class="button is-danger is-rounded" @click="(modal.item = props.row.id), (modal.estado = true)">
                        <span class="icon">
                            <i class="fas fa-trash"></i>
                            </span>
                            <span>Eliminar</span>
                    </button>
                </b-table-column>
            </b-table>
        </section>
        <!-- Tabla buefy de auditorías -->

        <!-- Modal de advertencia -->
        <div>
            <mdb-modal size="sm" :show="this.modal.estado" @close="confirmaEliminar(false)">
                <mdb-modal-header>
                    <mdb-modal-title>Eliminar</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body>¿Está seguro que desea eliminar esta auditoria?</mdb-modal-body>
                <mdb-modal-footer>
                    <button class="btn btn-danger btn-sm" @click="confirmaEliminar(false)">Cancelar</button>
                    <button class="btn btn-primary btn-sm" @click="confirmaEliminar(true)">Confirmar</button>
                </mdb-modal-footer>
            </mdb-modal>
        </div>
        <!-- Modal de advertencia -->

        <router-link to='/agregar'>
            <button class="button is-success is-rounded is-large btn-nueva">+ Nueva auditoría</button>
        </router-link>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import { mdbModal, mdbBtn, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
import "buefy/dist/buefy.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@mdi/font/css/materialdesignicons.min.css";
export default {
    name: 'Inicio',
    computed:{
        ...mapState(['usuario', 'auditorias'])
    },
    methods:{
        ...mapActions(['getAuditorias', 'eliminarAuditoria']),
        confirmaEliminar: function (eliminar) {
            if (eliminar === true) {
                this.eliminarAuditoria(this.modal.item);
                this.modal.estado = false;
                this.modal.item = 0;
            } else {
                this.modal.estado = false;
                this.modal.item = 0;
            }
        },
        mostrarProps: function (id) {
            console.log(id)
        }
    },
    created(){
        this.getAuditorias()
    },
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn
    },
    data() {
      return {
        modal: {
            estado: false,
            item: 0
        },
        columns: [
            {
                field: 'nombre',
                label: 'Auditoria',
                centered: true,
                searchable: true,
            },
            {
                field: 'direccion',
                label: 'Lugar',
                centered: true,
                searchable: true,
            },
            {
                field: 'fecha',
                label: 'Fecha',
                centered: true
            }
        ]

      };
    }
  }
</script>
<style scoped>

.btn-nueva {
    margin: 50px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>